(() => {
  'use strict';
  if (customElements.get('newsletter-component')) return;
  customElements.define('newsletter-component', class extends HTMLElement {
    constructor() {
      super();
      this.newsletter = this.querySelector('[data-newsletter-form]');
      this.stopSubmit = true;
      this.formID = null;
      try { this.sessionStorage = window.sessionStorage; } catch { this.sessionStorage = null; }
    }
    connectedCallback() {
      if (!this.newsletter || window.location.pathname === '/challenge') return;
      this.newsletterSubmit = event => this.newsletterSubmitEvent(event);
      this.newsletter.addEventListener('submit', this.newsletterSubmit);
      this.showMessage();
    }
    disconnectedCallback() {
      this.newsletter?.removeEventListener('submit', this.newsletterSubmit);
    }
    newsletterSubmitEvent(event) {
      if (!this.stopSubmit) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.removeStorage();
      this.writeStorage();
      this.stopSubmit = false;
      this.newsletter.submit();
    }
    writeStorage() {
      try { this.sessionStorage?.setItem('newsletter_form_id', this.newsletter.id); } catch {}
    }
    readStorage() {
      try { this.formID = this.sessionStorage?.getItem('newsletter_form_id') || null; } catch { this.formID = null; }
    }
    removeStorage() {
      try { this.sessionStorage?.removeItem('newsletter_form_id'); } catch {}
    }
    showMessage() {
      this.readStorage();
      const form = this.newsletter;
      const storedMatch = form.id === this.formID;
      const renderedSuccess = Boolean(form.querySelector('.newsletter__message--success'));
      const renderedError = Boolean(form.querySelector('.newsletter__message--error')?.textContent.trim());
      if (!storedMatch && !(this.formID === null && (renderedSuccess || renderedError))) return;
      const params = new URLSearchParams(window.location.search);
      const success = renderedSuccess || (storedMatch && params.get('customer_posted') === 'true');
      const error = renderedError || (storedMatch && params.has('accepts_marketing'));
      const heading = form.parentElement.querySelector('[data-newsletter-heading]');
      if (success) {
        form.classList.remove('has-error');
        form.classList.add('has-success');
      } else if (error) {
        form.classList.remove('has-success');
        form.classList.add('has-error');
      }
      if (success || error) {
        if (heading) { heading.classList.add('hidden'); form.classList.remove('hidden'); }
        window.addEventListener('load', () => this.scrollToForm(form), { once: true });
      }
    }
    scrollToForm(form) {
      const bounds = form.getBoundingClientRect();
      if (bounds.top >= 0 && bounds.left >= 0 && bounds.bottom <= window.theme.getWindowHeight() && bounds.right <= window.theme.getWindowWidth()) return;
      setTimeout(() => { window.theme.scrollTo(form.getBoundingClientRect().top); }, 500);
    }
  });
})();
